const FIN_ENGINE_PATH = '/service/fin_engine';
const MONEYBOX_PATH = '/v1/saving_wallet';

export const apiRoutes = {
  getBalance: () => `${FIN_ENGINE_PATH}${MONEYBOX_PATH}/balance`,
  topUpBalance: () => `${FIN_ENGINE_PATH}${MONEYBOX_PATH}/save`,
  withdraw: () => `${FIN_ENGINE_PATH}${MONEYBOX_PATH}/restore`
};
